import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    columnGap: "10rem",
    rowGap: "3rem",
    marginBottom: "3rem",
    padding: "0 1rem",
    paddingTop: "3rem",
    fontSize: "0.8rem",
  },
  logo: {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    height: "3rem",
    marginLeft: "2rem",
    fontSize: "1rem",
    color: "unset",
    textDecoration: "none",
  },
  subContainer: {
    flexGrow: 1,
    width: "36rem",
    display: "flex",
    flexDirection: "column",
    rowGap: "2rem",
  },
  previousProcessContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    border: `1px solid ${theme.lighterSnowColor}`,
    borderRadius: "10px",
  },
  previousProcess: {
    display: "flex",
    justifyContent: "space-between",
    margin: "1.5rem",
    "&:not(:first-child)": {
      borderTop: `1px solid ${theme.lighterSnowColor}`,
      marginTop: 0,
      paddingTop: "1.5rem",
    },
    "& > span:first-child": {
      width: "5rem",
      textTransform: "uppercase",
      fontWeight: 500,
    },
    "& > a": {
      color: theme.lightCoralColor,
      marginLeft: "auto",
    },
  },
  formContainer: {
    flexGrow: 1,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    rowGap: "2rem",
  },
  fieldsContainer: {
    padding: 0,
    marginTop: "1rem",
    border: `1px solid ${theme.lighterSnowColor}`,
    borderRadius: "10px",
    overflow: "hidden",
  },
  fieldsHeader: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "0.5rem",
    padding: "1.5rem",
    borderBottom: `1px solid ${theme.lighterSnowColor}`,
  },
  fieldsHeaderTitle: {
    fontSize: "0.9rem",
    fontWeight: 600,
  },
  errorMessage: {
    fontSize: "0.7rem",
    color: theme.lightCoralColor,
  },
  fieldsBody: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    border: "none",
    color: theme.dimGrayColor,
  },
  radioGroup: {
    display: "flex",
    flexDirection: "column",
    fontWeight: 500,
    "& input": {
      margin: 0,
    },
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: "0.5rem",
    cursor: "pointer",
    padding: "1.5rem",
    color: theme.dimGrayColor,
    backgroundColor: theme.whiteColor,
    "&:not(:first-child)": {
      borderTop: `1px solid ${theme.lighterSnowColor}`,
    },
    "& > span:last-child": {
      marginLeft: "auto",
    },
    '& input[type="radio"]': {
      display: "none",
    },
    '& input[type="radio"] + span': {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "0.7rem",
      height: "0.7rem",
      borderRadius: "50%",
      border: `1px solid ${theme.gainsboroColor}`,
      backgroundColor: theme.whiteColor,
    },
    '& input[type="radio"] + span > span': {
      width: "0.4rem",
      height: "0.4rem",
      borderRadius: "50%",
      backgroundColor: theme.whiteColor,
    },
    '& input[type="radio"]:checked + span > span': {
      backgroundColor: theme.darkGrayColor,
    },
  },
  labelInAccordion: {
    fontSize: "0.8rem",
    color: theme.dimGrayColor,
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    padding: "1.5rem",
    cursor: "pointer",
    '& input[type="checkbox"]': {
      display: "none",
    },
    '& input[type="checkbox"] + span': {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "0.7rem",
      height: "0.7rem",
      marginRight: "0.5rem",
      borderRadius: "50%",
      border: `1px solid ${theme.gainsboroColor}`,
      backgroundColor: theme.whiteColor,
    },
    '& input[type="checkbox"] + span > span': {
      width: "0.4rem",
      height: "0.4rem",
      borderRadius: "50%",
      backgroundColor: theme.whiteColor,
    },
    '& input[type="checkbox"]:checked + span > span': {
      backgroundColor: theme.darkGrayColor,
    },
  },
  inputsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  twoColumnInputContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    gap: "0.7rem",
  },
  inputContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: "100%",
    "& > input, & > select": {
      width: "100%",
      height: "2.5rem",
      padding: "0.7rem",
      border: `1px solid ${theme.lighterSnowColor}`,
      fontFamily: theme.fontFamilyQuestrial,
      fontSize: "0.8rem",
      color: theme.dimGrayColor,
    },
    "& > label": {
      width: "100%",
      position: "absolute",
      marginLeft: "0.7rem",
      color: theme.grayColor,
      pointerEvents: "none",
    },
    "& > input, select, label": {
      transition: "all 0.3s",
    },
  },
  textInputContainer: {
    "& > input:read-only": {
      outline: "none",
    },
    "& > input:focus, & > input:not(:placeholder-shown)": {
      paddingTop: "1.5rem",
    },
    "& > input:focus + label, & > input:not(:placeholder-shown) + label": {
      top: "0.3rem",
      fontSize: "0.6rem",
    },
  },
  selectInputContainer: {
    "& > select": {
      padding: 0,
      paddingLeft: "0.4rem",
    },
    "& > select:valid": {
      paddingTop: "0.9rem",
    },
    "& > select:valid + label": {
      top: "0.3rem",
      fontSize: "0.6rem",
    },
  },
  stripeElementContainer: {
    fontSize: "0.6rem",
    marginTop: "0.3rem",
    "& span": {
      marginLeft: "0.7rem",
      color: theme.grayColor,
    },
    "& div": {
      marginTop: "-1.1rem",
      borderRadius: "0",
      border: `1px solid ${theme.lighterSnowColor}`,
      boxShadow: "none",
      paddingTop: "1.1rem",
    },
  },
  btnContainer: {
    display: "flex",
  },
  payBtn: (props: any) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "3.5rem",
    width: props.matches ? "50%" : "100%",
    padding: 0,
    border: "none",
    borderRadius: "7px",
    marginLeft: "auto",
    textDecoration: "none",
    color: theme.whiteColor,
    background: `linear-gradient(to right, ${theme.blanchedAlmondColor}, ${theme.peachPuffColor})`,
    textTransform: "uppercase",
    fontSize: "0.9rem",
    fontWeight: 500,
    fontFamily: theme.fontFamilyArchivo,
    cursor: "pointer",
    "&:disabled": {
      color: theme.darkGrayColor,
      background: theme.snowColor,
    },
  }),
  isBeingProcessed: {
    position: "fixed",
    top: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    backgroundColor: theme.whiteColor,
  },
}));

export const stripeElementStyle = {
  base: {
    color: "#707070",
    fontSize: "12.8px",
    fontFamily: "'Archivo', sans-serif",
  },
  invalid: {
    color: "#fa755a",
  },
  complete: {
    color: "#57dd46",
  },
  empty: {},
};

export default useStyles;
